import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5030Class } from '../../CSPClass/CSP5030/csp5030-class';
import { environment } from '../../../../../../../src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class Csp5030Service {
  baseUrl: string=  environment.baseUrlCsp + 'CSP5030/';
  reportUrl: string=  environment.reportUrl;

  constructor(private http:HttpClient) { }

  Receipts(Csp5030Class:Csp5030Class):Observable<any>
  {
   
    return this.http.post<any>(this.baseUrl+'Receipts',Csp5030Class);
  }
csp5030(Csp5030Class:Csp5030Class): Observable<any>
{

  return this.http.post(this.reportUrl+'csp5030Controller/csp5030', Csp5030Class, {responseType: 'blob'});
}

}
